import React from "react";
import classNames from "classnames";

const RADIUS_DEFAULT = 9;
const RADIUS_UNDEFINED_CENTER = 5.2;
const RADIUS_UNDEFINED = 7;
const RADIUS_SUMMARY_CENTER = 8;
const RADIUS_SUMMARY_BORDER = 9;
const RADIUS_SUMMARY = 11;
const RADIUS_CROWD_SOURCED = 7;
const RADIUS_MAX = RADIUS_SUMMARY;

const ratio = (v) => v / RADIUS_DEFAULT;
const getRadius = (radius, size) => ratio(size) * radius;

const getCirclePath = (r, cx, cy) => `
    M ${cx}, ${cy}
    m ${-r}, 0
    a ${r},${r} 0 1,0 ${r * 2},0
    a ${r},${r} 0 1,0 -${r * 2},0
`;

const getHaloRadius = (radius, type) => {
  switch (type) {
    case "undefined":
      return getRadius(radius, RADIUS_UNDEFINED) * 1.4;
    case "summary":
      return getRadius(radius, RADIUS_SUMMARY) * 1.2;
    default:
      return getRadius(radius, RADIUS_DEFAULT) * 1.4;
  }
};

const Undefined = ({
  width,
  height,
  r,
  cx,
  cy,
  isFpGroup,
  isRadarView,
  ...props
}) => {
  if (!!isRadarView) {
    return (
      <g>
        <circle r={r} cx={cx} cy={cy} className={"drag-handle"} />
        <path
          d={`
                        ${getCirclePath(getRadius(r, RADIUS_UNDEFINED), cx, cy)}
                        ${getCirclePath(
                          getRadius(r, RADIUS_UNDEFINED_CENTER),
                          cx,
                          cy
                        )}
                    `}
          fillRule={"evenodd"}
          className={"circle"}
          fill="#00CA8D"
          {...props}
        />
      </g>
    );
  } else {
    if (!!isFpGroup) {
      return (
        <React.Fragment>
          <circle cx={cx} cy={cy} r="7" fill="#00CA8D" />
          <circle cx={cx} cy={cy} r="5.25" fill="white" />
          <g
            opacity="0.55"
            style={{
              transform: "translate(1.5px, 1.5px)",
            }}
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M9.05281 11.0367C8.40416 11.014 8.28116 9.41487 8.29219 7.91573C8.30484 6.31927 8.51881 5.64996 8.94784 5.41637C9.2587 5.24678 10.2984 5.31157 10.3488 5.31477C11.7752 5.40384 12.3345 6.3574 12.3345 7.23976C12.3345 8.98502 11.3137 9.13355 10.4451 9.67459C9.7429 10.1119 9.70603 11.0367 9.05281 11.0367Z"
              fill="#00CA8D"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M7.70366 5.94048C7.69747 5.45144 7.34785 5.36851 6.95112 5.33331C6.58885 5.30051 5.48453 5.27944 4.97584 5.35731C4.26636 5.4669 4.16247 6.65965 4.14283 7.96706C4.12129 9.4318 4.24053 10.9949 4.87868 11.0355C4.88272 11.0355 4.88675 11.0363 4.89052 11.0363C5.11149 11.044 5.26437 10.9472 5.39141 10.8011C5.57766 10.587 5.70631 10.2656 5.91463 10.0094C6.29548 9.54193 6.55574 9.41633 6.96054 9.07528C7.57743 8.55557 7.26657 7.914 7.28002 7.42389C7.29025 7.06523 7.40625 6.82924 7.45739 6.72685C7.63503 6.36953 7.70609 6.14287 7.70366 5.94048Z"
              fill="#00CA8D"
            />
          </g>
        </React.Fragment>
      );
    }

    return (
      <React.Fragment>
        <circle cx={cx} cy={cy} r="7" fill="#00CA8D" />
        <circle cx={cx} cy={cy} r="5.25" fill="white" />
      </React.Fragment>
    );
  }
};

const Summary = ({ r, cx, cy, ...props }) => (
  <g>
    <circle
      r={getRadius(r, RADIUS_SUMMARY)}
      cx={cx}
      cy={cy}
      className={"drag-handle"}
    />
    <path
      d={`
                ${getCirclePath(getRadius(r, RADIUS_SUMMARY), cx, cy)}
                ${getCirclePath(getRadius(r, RADIUS_SUMMARY_BORDER), cx, cy)}
                ${getCirclePath(getRadius(r, RADIUS_SUMMARY_CENTER), cx, cy)}
              `}
      fillRule={"evenodd"}
      className={"circle"}
      {...props}
    />
  </g>
);

const Default = ({ r, ...props }) => (
  <circle r={getRadius(r, RADIUS_DEFAULT)} className={"circle"} {...props} />
);

const Crowd = ({ r, ...props }) => (
  <circle
    r={getRadius(r, RADIUS_CROWD_SOURCED)}
    className="circle"
    {...props}
  />
);

const Established = ({
  width,
  height,
  r,
  cx,
  cy,
  isFpGroup,
  isRadarView,
  ...props
}) => {
  //     if (!isFpGroup) {
  //         return <circle cx={cx}
  //         cy={cy} r={r} fill="#016998"/>
  //     } else {
  // return <React.Fragment>
  // <circle cx={cx}
  //                         cy={cy} r={r} fill="#016998"/>
  //         <g opacity="0.55">
  //         <path fillRule="evenodd" clipRule="evenodd" d="M9.23528 11.441C8.49117 11.415 8.35006 9.58048 8.36272 7.8607C8.37723 6.02928 8.6227 5.26147 9.11486 4.9935C9.47148 4.79894 10.6642 4.87328 10.722 4.87695C12.3584 4.97912 13 6.07302 13 7.08525C13 9.08737 11.8289 9.25775 10.8325 9.87843C10.0269 10.3801 9.98464 11.441 9.23528 11.441Z" fill="white"/>
  //         <path fillRule="evenodd" clipRule="evenodd" d="M7.68758 5.5947C7.68048 5.03368 7.2794 4.93855 6.82429 4.89817C6.40869 4.86054 5.14185 4.83638 4.55829 4.9257C3.74439 5.05142 3.62521 6.41972 3.60267 7.91955C3.57797 9.59986 3.71475 11.3931 4.44682 11.4396C4.45146 11.4396 4.45609 11.4405 4.46041 11.4405C4.7139 11.4493 4.88928 11.3383 5.03501 11.1707C5.24868 10.925 5.39626 10.5564 5.63525 10.2624C6.07214 9.7262 6.37071 9.58212 6.83509 9.19087C7.54277 8.59467 7.18615 7.85868 7.20159 7.29643C7.21332 6.88499 7.3464 6.61427 7.40507 6.49681C7.60885 6.0869 7.69036 5.82688 7.68758 5.5947Z" fill="white"/>
  //         </g>
  // </React.Fragment>
  //     }
  return <circle cx={cx} cy={cy} r={r} fill="#016998" />;
};

const getComponent = (type) => {
  switch (type) {
    case "undefined":
      return Undefined;
    case "summary":
      return Summary;
    case "crowd":
      return Crowd;
    // case "established":
    //   return Established;
    default:
      return Default;
  }
};

const Halo = ({ size, type, ...props }) => (
  <circle
    r={getHaloRadius(size, type)}
    className={"halo"}
    opacity={0.1}
    stroke={"none"}
    {...props}
  >
    <animate
      attributeName="opacity"
      begin="0s"
      dur="3s"
      values="0.6; 0.1; 0.6"
      keyTimes="0; 0.5; 1"
      repeatCount="indefinite"
      from={0.1}
      to={0.6}
    />
  </circle>
);

export default ({
  isRadarView,
  type,
  size,
  x,
  y,
  className,
  halo,
  dragged,
  deleting,
  fill,
  watermarkLink,
  isFpGroup,
}) => {
  const svgSize = size * (RADIUS_MAX / RADIUS_DEFAULT);
  const cx = svgSize / 2;
  const cy = svgSize / 2;
  const svgPosition = {};
  if (x) {
    svgPosition.x = x - svgSize / 2;
  }
  if (y) {
    svgPosition.y = y - svgSize / 2;
  }
  let type2 = type;
  if (!!type && (typeof type === "string" || type instanceof String)) {
    type2 = (type || "")?.replace(/\s/g, "");
  }
  const classes = classNames(className, "phenomenon-indicator", type2, {
    dragged,
    deleting,
  });

  const Component = getComponent(type);

  return (
    <svg
      className={classes}
      width={svgSize}
      height={svgSize}
      {...svgPosition}
      fill={fill}
    >
      {halo && <Halo r={getHaloRadius(size / 2, type)} cx={cx} cy={cy} />}
      <Component
        r={size / 2}
        cx={cx}
        cy={cy}
        className={"circle"}
        fill={fill}
        isFpGroup={isFpGroup}
        isRadarView={isRadarView}
        width={svgSize}
        height={svgSize}
      />
      {!!isFpGroup &&
        // type !== "established" &&
        String(type) !== "undefined" && (
          <image
            x={cx - size / 2}
            y={cy - size / 2}
            width={size}
            height={size}
            xlinkHref={
              watermarkLink ||
              "https://go2.futuresplatform.com/sites/default/files/watermark-fp.png"
            }
            style={{ opacity: 1 }}
          />
        )}
    </svg>
  );
};
